const request = (url, options = {}) => {
  let uri = url
  const { method, body, headers, params } = options

  if (params) {
    uri += `?${new URLSearchParams(params).toString()}`
  }

  return fetch(uri, { method, credentials: 'include', headers, body })
    .then(result => result.json())
    .then(response => {
      if (response.success === true) {
        return response.data
      }
      throw response
    })
}

const get = (url, options = {}) => request(url, { method: 'GET', ...options })

const post = (url, data) => {
  return request(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

const put = (url, data) => {
  return request(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

export { get, post, put }
